import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppConfirmService } from 'src/app/shared/services/app-confirm/app-confirm.service';
import { Chunk } from '../../chunk.dto';
import { ChunkService } from '../../chunk.service';

@Component({
  selector: 'app-delete-chunk',
  standalone: true,
  imports: [TranslateModule, MatIconModule],
  template: `
    <div class="interactive-item" (click)="deleteChunk()">
      <div class="interactive-item__content">
        <mat-icon class="interactive-item__icon" aria-hidden="true">delete_forever</mat-icon>
        <span class="interactive-item__text">{{ 'ChunkDisplayer.chunkOptions.removeChunk' | translate }}</span>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteChunkComponent {
  @Input() chunk: Chunk;
  @Input() contentID: string;
  @Output() deleted = new EventEmitter<void>();
  @Output() actionTriggered = new EventEmitter<void>();

  private chunkService = inject(ChunkService);
  private confirmService = inject(AppConfirmService);
  private translate = inject(TranslateService);

  deleteChunk(): void {
    this.actionTriggered.emit(); // Close the parent overlay immediately

    if (!this.chunk || !this.contentID) {
      return;
    }

    this.confirmService.confirm({ message: this.translate.instant('Confirm.DeleteChunk') }).subscribe((res) => {
      if (res) {
        this.chunkService.deleteChunk({ chunkID: this.chunk._id, contentID: this.contentID, type: this.chunk.type }).subscribe(() => {
          this.deleted.emit();
        });
      }
    });
  }
}
